export default {
	state: {
		// dataUploadFilePath: []
		dataUploadFilePath: {}
	},

	mutations: {
		SET_VALUE_TO_PASS_FILE(state, {data,componentId, id} ) {
			// // let component  = state.dataUploadFilePath.filter(item => {
			// // 	return item.component_id === componentId });
			// // 	// console.log(component);
			// // if(component && component[0].component_id == componentId) {
			// // 	// state.dataUploadFilePath =  [...state.dataUploadFilePath, [data]];
			// // 	state.dataUploadFilePath.push(data);
			// // }
			// // else {
			// // 	state.dataUploadFilePath[component] = data;
			// // }
			//
			// // let index  = state.dataUploadFilePath.findIndex(item => item.id === id);
			// // if(index === -1){
			// // 	state.dataUploadFilePath.push(data);
			// // } else {
			//
			// // }

			
			let keyLength = Object.keys(state.dataUploadFilePath).length;
			if(keyLength === 0){
				//Code is run first time,
				Vue.set(state.dataUploadFilePath, componentId, data);
			} else {
				let objKeys = Object.keys(state.dataUploadFilePath);

				const objkey = objKeys.filter((i, index) => {
					return i === componentId;
				});
				// console.log(objkey);
				if(objkey.length != 0 ) {
					const convertedToArray = state.dataUploadFilePath[componentId];
					if(convertedToArray.length > 0){
						const component  = state.dataUploadFilePath[componentId].filter(item => {
							return item.id === data[0].id });
						if (!component.length > 0){
							convertedToArray.push(data[0]);
							state.dataUploadFilePath[componentId] = convertedToArray;
							// Vue.set(state.dataUploadFilePath, componentId, data);
						}
					}
				}
				else {
					Vue.set(state.dataUploadFilePath, componentId, data);
				}
			}

			//Vue.set(state.dataUploadFilePath, componentId, data); // By Adil
			// state.dataUploadFilePath
			// var index = 0 ;

			// if (state.dataUploadFilePath.length > 0) {
			// 	let replace = state.dataUploadFilePath.some((da, i) => {
			// 		index++
			// 		return da.path == data.path
			// 	});
			// 	if (replace) {
			// 		state.dataUploadFilePath[index] = data
			// 	}
			// 	else {
			// 		state.dataUploadFilePath.push(data); 
			// 	}
			// }
			// else 
			// {
			// 	state.dataUploadFilePath.push(data); 
			// }
			// 
			// state.dataUploadFilePath[componentId] =  data ; 
			
			// state.dataUploadFilePath = data ; 
			// state.dataUploadFilePath = Object.assign({}, data)
			// Object.keys(data).forEach( key => {
			// 	Vue.set(state.dataUploadFilePath, key, data[key])
			// })
		},
	},

	actions: {
		setValueToPassFile({ commit }, {data,componentId,id}) {
			
			commit('SET_VALUE_TO_PASS_FILE', {data,componentId,id} );
		}
	}
}
